import { useTranslation } from "react-i18next";

interface DocumentAwardProps {
    srcLogo: string;
}

const DocumentAward = (props: DocumentAwardProps) => {
    const { srcLogo } = props;
    const imgSrc = `${import.meta.env.VITE_API_HOST}${srcLogo}`;
    const { t } = useTranslation();

    return (
        <div className="mb-2">
            <p className="text-xs mb-1">{t("awards")}</p>
            <img src={imgSrc} className="relative rounded-md" height="28" width="127" />
        </div>
    );
};

export default DocumentAward;
